module.exports = __webpack_public_path__ + "media/bootstrap-icons/pencil-square-1bd74fe2.svg";